import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'under_12_over_18_enter_age_youngest_worker'

export const dataPointDefinition = {
  retracedId: 'under_12_over_18_enter_age_youngest_worker',
  name: 'If under 12 or over 18, please enter the age of the youngest worker:',
  description: 'Please enter a whole number, not a decimal. E.g., enter 10, 11, 19, 20, 21. Do not enter 19.25.',
  meta: {
    slcpMeta: {
      key: 'cl-1--2-8f',
      number: 'RH-CHI-3',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],cl-1--2,Under 12;Over 18',
      machineShowHide: '[2],cl-1--2,1;9',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'cl-1--2-8f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 26480,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
